import { c as _c } from "react/compiler-runtime";
import { times } from '@cc-shopping/utils/function/times';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/system';
import { CardsApprovalLabel } from './CardsApprovalLabel';
import { type ApprovalOddsValues, Likelihood } from './constants';
type ApprovalLineSectionProps = {
  halfWay: boolean;
  isFilled: boolean;
  color: string;
};
const ApprovalLineSection = t0 => {
  const $ = _c(2);
  const {
    isFilled,
    halfWay,
    color
  } = t0;
  const theme = useTheme();
  const backgroundColor = isFilled ? color : theme.palette.grey[200];
  const t1 = halfWay ? `linear-gradient(90deg, ${backgroundColor} 50%, ${theme.palette.grey[200]} 50%)` : backgroundColor;
  let t2;
  if ($[0] !== t1) {
    t2 = <Box data-testid="approval-line-section" display="inline-block" height="6px" width="100%" gridRow={2} sx={{
      background: t1
    }} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export type CardsApprovalLineProps = {
  approvalLikelihood: ApprovalOddsValues | null;
  desktopStyle?: boolean;
};
export const CardsApprovalLine = ({
  approvalLikelihood,
  desktopStyle
}: CardsApprovalLineProps) => {
  const isPoor = approvalLikelihood?.label === Likelihood.Poor;
  const isExcellent = approvalLikelihood?.label === Likelihood.Excellent;
  return <>
      <Box maxWidth="312px" display="grid" gridTemplateColumns="repeat(5, 1fr)" gridRow={1} gridColumn="span 5" marginBottom={1}>
        <Box position="relative" left={isPoor ? '33%' : 'auto'} textAlign="center" marginBottom={2} sx={theme => ({
        gridColumnStart: approvalLikelihood?.placement,
        [theme.breakpoints.up('md')]: {
          left: isExcellent ? '22%' : isPoor ? '33%' : 'auto'
        }
      })}>
          {approvalLikelihood && <CardsApprovalLabel approvalLikelihood={approvalLikelihood} desktopStyle={desktopStyle} />}
        </Box>
      </Box>
      {times(5, idx => <ApprovalLineSection key={idx} halfWay={!isPoor && idx === (approvalLikelihood?.placement ?? 0) - 1} isFilled={idx < (approvalLikelihood?.placement ?? 0)} color={approvalLikelihood?.color ?? ''} />)}
    </>;
};